import(/* webpackMode: "eager" */ "/vercel/path0/src/app/de/blog/botox-preise-2026/page.tsx");
